module.exports = __webpack_public_path__ + "static/media/resultBackground.b715c05c.png";